var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoToIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "",
    stroke: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("title", null, "External-Link"), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    strokeWidth: 1.392,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "External-Link"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,12 L20,18 C20,19.1046 19.1046,20 18,20 L6,20 C4.89543,20 4,19.1046 4,18 L4,6 C4,4.89543 4.89543,4 6,4 L12,4",
    id: "Path",
    stroke: "#2C7F75",
    strokeWidth: 1.392,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,4 L19,4 C19.5523,4 20,4.44772 20,5 L20,8",
    id: "Path",
    stroke: "#2C7F75",
    strokeWidth: 1.392,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 13,
    x2: 19,
    y2: 5,
    id: "Path",
    stroke: "#2C7F75",
    strokeWidth: 1.392,
    strokeLinecap: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoToIcon);
export default __webpack_public_path__ + "static/media/goToIcon.a2b3a0671e0950ec3ced9a2e403a2f41.svg";
export { ForwardRef as ReactComponent };